'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dolphinNativeBridge = require('dolphin-native-bridge');

var _dofOverlay = require('../dof-overlay');

var _dofOverlay2 = _interopRequireDefault(_dofOverlay);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');
var platform = weex.config.env.platform;

var isWeb = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && platform.toLowerCase() === 'web';
exports.default = {
  mixins: [_diablo2.default],
  components: { DofOverlay: _dofOverlay2.default },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pos: {
      type: String,
      default: 'bottom'
    },
    // 背景色，即按钮上方的横条颜色，暂不开放
    popupColor: {
      type: String,
      default: ''
    },
    overlayCfg: {
      type: Object,
      default: function _default() {
        return {
          hasAnimation: true,
          timingFunction: ['ease-in', 'ease-out'],
          duration: 300,
          opacity: 0.3
        };
      }
    },
    // height: {
    //   type: [Number, String],
    //   default: 840
    // },
    standOut: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 750
    },
    animation: {
      type: Object,
      default: function _default() {
        return {
          // timingFunction: 'ease-in'
          timingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)'
        };
      }
    },
    title: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: '取消'
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleStyle: {
      type: Object,
      default: function _default() {}
    },
    defaultBtnStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    itemStyle: {
      type: Object,
      default: function _default() {}
    },
    borderRadius: {
      type: String,
      default: '32px'
    }
  },
  data: function data() {
    return {
      haveOverlay: true,
      isOverShow: true,
      bottomArc: 0,
      diabloBg: '#1e2326'
    };
  },
  computed: {
    isNeedShow: function isNeedShow() {
      var _this = this;

      try {
        setTimeout(function () {
          _this.appearPopup(_this.show);
        }, 50);
      } catch (error) {
        this.$nextTick(function () {
          _this.appearPopup(_this.show);
        });
      }
      return this.show;
    },

    // _height() {
    //   this.appearPopup(this.show, 150)
    //   return this.popHeight
    // },
    // transformValue() {
    //   return this.getTransform(this.pos, this.width, this.popHeight, true)
    // },
    padStyle: function padStyle() {
      var pos = this.pos,
          width = this.width,
          popupColor = this.popupColor;

      var style = {
        width: width + 'px',
        backgroundColor: popupColor ? popupColor : this._isDiablo ? '#101315' : '#F9F9F9'
        // backgroundColor: '#616C73'
      };
      if (pos === 'bottom') {
        style.bottom = '0px';
        style.transform = 'translateY(100%)';
        style.borderTopLeftRadius = this.borderRadius;
        style.borderTopRightRadius = this.borderRadius;
      }
      return style;
    },
    bottomIpxStyle: function bottomIpxStyle() {
      var style = {
        backgroundColor: this._isDiablo ? this.diabloBg : '#ffffff',
        paddingBottom: (this.isipx ? 84 : 16) + 'px'
      };
      return style;
    },

    isipx: function isipx() {
      if (this.bottomArc) return true;
      return weex && (weex.config.env.deviceModel === 'iPhone10,3' || weex.config.env.deviceModel === 'iPhone10,6' || // iphoneX
      weex.config.env.deviceModel === 'iPhone11,8' || // iPhone XR
      weex.config.env.deviceModel === 'iPhone11,2' || // iPhone XS
      weex.config.env.deviceModel === 'iPhone11,4' || weex.config.env.deviceModel === 'iPhone11,6' || // iPhone XS Max
      weex.config.env.deviceModel === 'iPhone12,1' || // iPhone11
      weex.config.env.deviceModel === 'iPhone12,3' || weex.config.env.deviceModel === 'iPhone12,5' || // iPhone 11 Pro iPhone 11 Pro Max
      weex.config.env.deviceModel === 'iPhone13,1' || weex.config.env.deviceModel === 'iPhone13,2' || // iPhone12 Mini && iPhone12
      weex.config.env.deviceModel === 'iPhone13,3' || //iPhone12 Pro
      weex.config.env.deviceModel === 'iPhone13,4' || // iPhone12 Pro Max
      weex.config.env.deviceModel === 'iPhone14,4' || //iPhone 13 mini
      weex.config.env.deviceModel === 'iPhone14,5' || //iPhone 13
      weex.config.env.deviceModel === 'iPhone14,2' || //iPhone 13 Pro
      weex.config.env.deviceModel === 'Iphone14,3') //iPhone 13 Pro Max
      ;
    }

    // popHeight() {
    //   // 根据下拉菜单内容计算bottom距离
    //   // var length = this.items.length
    //   //add by lau 可以不传递item,并且自动获取高度
    //   var length = (this.items && this.items.length) || 0
    //   var height,
    //     extraHeight = this.isipx ? 84 : 16 // 84=16+68

    //   if (this.items && this.items.length > 0) {
    //     // var len = (length + 1) * 100 + 80;
    //     height = (length + 1) * 96 + extraHeight
    //   } else {
    //     height = this.popHeight + 80
    //   }
    //   height = this.title ? height + 108 : height
    //   return height
    // }
  },
  created: function created() {
    var _this2 = this;

    _dolphinNativeBridge.Bridge.getAllBarHeight().then(function (res) {
      _this2.bottomArc = res.bottomArc || 0;
    });
  },

  methods: {
    // '取消'按钮点击事件
    actionsheetBtnClick: function actionsheetBtnClick(buttonText) {
      this.appearPopup(false);
      this.$refs.overlay.appearOverlay(false);
      this.$emit('dofCancelClick', { buttonText: buttonText });
    },


    // 菜单项点击事件
    actionsheetItemClick: function actionsheetItemClick(item, index) {
      this.appearPopup(false);
      this.$refs.overlay.appearOverlay(false);
      this.$emit('dofItemClick', { item: item, index: index });
    },
    handleTouchEnd: function handleTouchEnd(e) {
      // 在支付宝上面有点击穿透问题
      var platform = weex.config.env.platform;

      platform === 'Web' && e.preventDefault && e.preventDefault();
    },
    hide: function hide() {
      this.appearPopup(false);
      this.$refs.overlay.appearOverlay(false);
    },
    dofOverlayBodyClicking: function dofOverlayBodyClicking() {
      this.show && this.appearPopup(false);
    },
    appearPopup: function appearPopup(show) {
      var _this3 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

      var popupEl = this.$refs['dof-popup'];
      if (!popupEl) {
        return;
      }
      animation.transition(popupEl, _extends({
        styles: {
          transform: this.getTransform(this.pos, show)
        },
        duration: duration,
        delay: 0
      }, this.animation), function () {
        if (!show) {
          _this3.$emit('dofPopupOverlayClicked', { pos: _this3.pos });
        }
      });
    },
    getTransform: function getTransform(pos, show) {
      var _transform = void 0;
      switch (pos) {
        case 'top':
        case 'left':
          _transform = 'translateY(' + (show ? 0 : -100) + '%)';
          break;
        case 'bottom':
        case 'right':
          _transform = 'translateY(' + (show ? 0 : 100) + '%)';
          break;
      }
      return _transform;
    },
    textStyleOps: function textStyleOps(item) {
      return item.textColor ? { color: item.textColor } : { color: this._isDiablo ? '#cfcfd0' : '#1E2E37' };
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-actionsheet/index.vue
// module id = 301
// module chunks = 0 1